/**
 * Stream / telemetry state colors aligned with client theme (used by asset labels, etc.).
 */
export const COLOR_SCHEME = {
	active: '#0696d7', // brand: COLORS.blue500,
	success: '#6a9728', // status-ok: COLOR.green600,
	warning: '#faa21b', // status-warning: COLORS.yellow500,
	offline: '#4d4d4d', // info: COLORS.charcoal80,
	nodata: '#4d4d4d', // same as offline here
	error: '#eb5555', // status-error: COLORS.red500,
};
